import React from "react";
import img from "./imgs/logo_black.png";
import "./LoginForm.css"; // reuse same CSS

function ResetPasswordForm({
  formData,
  errors,
  isSubmitting,
  onChange,
  onSubmit,
  onBackToLogin
}) {
  return (
    <div className="login-container">
      <div className="login-logo">
        <img src={img} alt="logo" width="200px" />
      </div>

      <form className="login-box" onSubmit={onSubmit}>
        <h2>إعادة تعيين كلمة المرور</h2>

        <div className="input-group">
          <label>اسم المستخدم</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={onChange}
            placeholder="ادخل اسم المستخدم"
          />
          {errors.username && (
            <small className="error-text">{errors.username}</small>
          )}
        </div>

        <div className="input-group">
          <label>كلمة المرور القديمة</label>
          <input
            type="password"
            name="oldPassword"
            value={formData.oldPassword}
            onChange={onChange}
            placeholder="••••••••"
          />
          {errors.oldPassword && (
            <small className="error-text">{errors.oldPassword}</small>
          )}
        </div>

        <div className="input-group">
          <label>كلمة المرور الجديدة</label>
          <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={onChange}
            placeholder="••••••••"
          />
          {errors.newPassword && (
            <small className="error-text">{errors.newPassword}</small>
          )}
        </div>

        <div className="input-group">
          <label>تأكيد كلمة المرور الجديدة</label>
          <input
            type="password"
            name="confirmNewPassword"
            value={formData.confirmNewPassword}
            onChange={onChange}
            placeholder="••••••••"
          />
          {errors.confirmNewPassword && (
            <small className="error-text">{errors.confirmNewPassword}</small>
          )}
        </div>

        {errors.general && (
          <small className="error-text">{errors.general}</small>
        )}

        <button type="submit" className="login-btn" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <span className="loading"></span> جارٍ الحفظ...
            </>
          ) : (
            "تغيير كلمة المرور"
          )}
        </button>

        <button
          type="button"
          className="login-btn"
          style={{ marginTop: "10px" }}
          onClick={onBackToLogin}
          disabled={isSubmitting}
        >
          رجوع لتسجيل الدخول
        </button>
      </form>
    </div>
  );
}

export default ResetPasswordForm;